import storage from "./storage";

export const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;

export const handleError = (error) => {
  const errorResponse =
    error?.response?.data?.detail ||
    error?.response?.data?.info?.description ||
    {};
  if (error?.response?.status === 401 && window.location.pathname !== "/") {
    storage.clear();
    window.location.href = "/";
    return {};
  }
  return errorResponse;
};

export const getURLWithParams = (url, queryParams) => {
  const paramKeys = Object.keys(queryParams);

  if (paramKeys.length === 0) return url;

  // Filter out null values from the parameters
  const filteredParams = Object.fromEntries(
    Object.entries(queryParams).filter(([key, value]) => value),
  );

  const params = new URLSearchParams(filteredParams).toString();

  const URLWithParams = `${url}?${params}`;
  return URLWithParams;
};

export function formatPhoneNumberPayloadBE(val) {
  if (val === 0 || val === "0") return "+62";
  if (val === 62 || val === "62") return "+62";
  if (val && String(val)?.[0] === "0") {
    return `+62${String(val)?.substring(1, String(val)?.length)}`;
  }
  if (val && String(val)?.[0] === "6" && String(val)?.[1] === "2") {
    return `+62${String(val)?.substring(2, String(val)?.length)}`;
  }

  return `+62${val ?? ""}`;
}

export function formatPhoneNumberInForm(val) {
  if (
    val &&
    String(val)?.[0] === "+" &&
    String(val)?.[1] === "6" &&
    String(val)?.[2] === "2"
  ) {
    return String(val)?.substring(3, String(val)?.length);
  }

  return val;
}

export const formatNumberOnly = (value) => {
  if (value === undefined) return;

  return value?.replace(/\D/g, "");
};
